import { SxProps, Theme } from '@mui/material';

export const spreadSx = (sx: SxProps<Theme> | undefined) => {
  return Array.isArray(sx) ? sx : [sx];
};
